import React, { Suspense } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { App as AppProvider } from 'antd'
import { BugsnagWrapper } from './config/BugsnagWrapper'
import Loading from './shared/components/Loading'
import { store, persistor } from './redux/store'
import App from './App'
import QueryClientWrapper from './services/api/QueryClientWrapper'
import AppConfigProvider from './config/AppConfigProvider'

// Lazy load devtools only in development
const ReactQueryDevtools =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() =>
        import('@tanstack/react-query-devtools').then(d => ({
          default: d.ReactQueryDevtools
        }))
      )
    : () => null

const Root: React.FC = () => {
  return (
    <QueryClientWrapper>
      <BugsnagWrapper>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Loading />}>
              <AppConfigProvider>
                <AppProvider>
                  <App />
                </AppProvider>
              </AppConfigProvider>
            </Suspense>
          </PersistGate>
        </Provider>
      </BugsnagWrapper>
      {process.env.NODE_ENV === 'development' && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" position="bottom" />
        </Suspense>
      )}
    </QueryClientWrapper>
  )
}

export default Root
